import { getAxios } from "./ApiInstance";

export const LoginAdmin=(info, callback)=>{
    getAxios().post("login/",info).then(response =>{ 
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const AddCourseApi=(callback)=>{
    getAxios().post("course/add/").then(response =>{ 
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const getCourseListAPI=async () => {
    try{
        const result =await getAxios().get("course/all/");
        return result.data;
    }catch (error){
        return error;
    }
}
export const getCommentsListApi=async () => {
    try{
        const result =await getAxios().get("comment/");
        return result.data;
    }catch (error){
        return error;
    }
};
export const getUserListAPI=async () => {
    try{
        const result =await getAxios().get("user/all/");
        return result.data;
    }catch (error){
        return error;
    }
};
export const getPagesListApi=async () => {
    try{
        const result =await getAxios().get("page/all/");
        return result.data;
    }catch (error){
        return error;
    }
};
export const getPageDetailApi=async (name) => {
    try{
        const result =await getAxios().get(`page/${name}/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const getCourseDetailAPI=async (id) => {
    try{
        const result =await getAxios().get(`course/${id}/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const chatMessageApi=async (id) => {
    try{
        const result =await getAxios().get(`comment/${id}/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const UpdateCourseAPI=(info, callback)=>{
    getAxios().post("course/update/",info).then(response =>{ 
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const changeCourseDetailAPI=(info, callback)=>{
    getAxios().post("course/edit/",info).then(response =>{ 
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};
export const AnswerApi=(info, callback)=>{
    getAxios().post("comment/",info).then(response =>{ 
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};

export const EditePageApi=(info, callback)=>{
    getAxios().post("page/update/",info).then(response =>{ 
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};

export const DeletePageApi=(info, callback)=>{
    getAxios().post("page/delete/",info).then(response =>{ 
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};

export const AddPageServicesApi=(info, callback)=>{
    getAxios().post("page/add/",info).then(response =>{ 
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};














export const EditeServicesApi=(id,info, callback)=>{
    getAxios().post("services/"+id,info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const AddservicesApiApi=(info, callback)=>{
    getAxios().post("services/",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const ServicesListPrice=async () => {
    try{
        const result =await getAxios().get("services");
        return result.data;
    }catch (error){
        return error;
    }
};
export const CommentListApi=async () => {
    try{
        const result =await getAxios().get("feedbacks");
        return result.data;
    }catch (error){
        return error;
    }
};
export const RemoveCommentApi=(id, callback)=>{
    getAxios().delete("feedbacks/"+id).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const getShopInfo=async () => {
    try{
        const result =await getAxios().get("getshopinfo");
        return result.data;
    }catch (error){
        return error;
    }
};
export const EditShopInformationApi=(info, callback)=>{
    getAxios().post("editshopinfo/",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const getBlockTimesApi=async () => {
    try{
        const result =await getAxios().get("blocktimes");
        return result.data;
    }catch (error){
        return error;
    }
};
export const RemoveBlockTimeApi=(id, callback)=>{
    getAxios().delete("blocktimes/"+id).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const addBlockTimeApi=(info, callback)=>{
    getAxios().post("blocktimes/",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const UpdatePasswordAPI=(info, callback)=>{
    getAxios().post("editpassword/",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const getDayListAPI=async (date) => {
    try{
        const result =await getAxios().get(`reservation/dailyget/?date=${date}`);
        return result.data;
    }catch (error){
        return error;
    }
};

export const getDayList2API=async () => {
    try{
        const result =await getAxios().get(`/reservation/getdays2`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const getTimeByDayApi=async (date) => {
    try{
        const result =await getAxios().get(`/reservation/gettimeofday/`+date);
        return result.data;
    }catch (error){
        return error;
    }
};

export const getCustomerListApi=async () => {
    try{
        const result =await getAxios().get(`user/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const getListAccounting=async (date,filter) => {
    try{
        const result =await getAxios().get(`/reservation/barberget/?date=${date}&filter=${filter}`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const ReseveServiceWithBarberApi=(info, callback)=>{
    getAxios().post("reservation/barbercreate",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};

export const ReseveServiceWithBarber2Api=(info, callback)=>{
    getAxios().post("reservation/barbercreate",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const compeleteResevationApi=(info,id, callback)=>{
    getAxios().post("reservation/completereserve/"+id,info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const getuserRepoartApi=async (id) => {
    try{
        const result =await getAxios().get(`/reservation/barberget/?userid=${id}`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const getWorkSampleApi=async (id) => {
    try{
        const result =await getAxios().get(`/worksamples`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const RemoveSampleWorkApi=(id, callback)=>{
    getAxios().delete("worksamples/"+id).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const RemoveFilekApi=(id, callback)=>{
    getAxios().delete("worksamples/deletemedia/"+id).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const updateWorkSampleApi=(info,id, callback)=>{
    getAxios().post("worksamples/"+id,info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const uploadFileApi=(info, callback)=>{
    getAxios().post("worksamples/upload",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};
export const createWorkSampleApi=(info, callback)=>{
    getAxios().post("worksamples/",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};

export const setTokenForNotifAPI=(info, callback)=>{
    getAxios().post("settoken/",info).then(response =>{ 
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.response.data);
        })
};